import React from 'react';
import { ReportAnIssueButton } from '@fiverr-private/content_reporting';

export const ReportGigItem: React.FC = () => (
  <ReportAnIssueButton variant="button" shouldTriggerAuth shouldTriggerActivation />
);
